export async function hashStr(str: string, salt: string = "") {
  const cleaned = str.trim().toLowerCase();
  const utf8 = new TextEncoder().encode(salt + cleaned);

  const hashBuffer = await crypto.subtle.digest("SHA-256", utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer, 0, hashBuffer.byteLength));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, "0")).join("");

  return hashHex;
}
